import { Box, Button, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { MediaQueryProps } from '../types';

export const HelpSectionWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => !['ismobile', 'islaptop', 'iswidescreen'].includes(prop),
})<MediaQueryProps>`
  background-color: ${({ theme }) => theme.palette.divider};
  display: flex;
  flex-direction: ${({ ismobile }) => (ismobile ? 'column' : 'row')};
  justify-content: space-between;
  align-items: center;
  gap: ${({ ismobile }) => (ismobile ? '20px' : '40px')};
  padding: ${({ ismobile, islaptop, iswidescreen }) => {
    if (ismobile) return '40px 60px';
    if (islaptop) return '40px 10%';
    if (iswidescreen) return '40px 15%';
    return '40px 10%';
  }};
`;

export const HelpSectionDescription = styled(Box)`
  padding: 13px 0;
`;

export const HelpSectionLinkList = styled('ul')`
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: column;
  font-size: 16px;
  gap: 10px;
  min-width: 256px;
  padding-left: 0;
`;

export const HelpSectionImage = styled('img', {
  shouldForwardProp: (prop: string) => prop !== 'islaptop',
})<MediaQueryProps>`
  height: 150px;
  display: ${({ islaptop }) => (islaptop ? 'none' : 'initial')};
`;
